import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { getOrgTermsContent } from '../../../content/utils.js';
import FormModal from '../../FormModal.jsx';
import InitiativeCategoryForm from './InitiativeCategoryForm.jsx';
import { selectCurrentOrganizationId } from '../../../modules/auth.js';
import {
  createInitiativeCategory,
  deleteInitiativeCategory,
  retrieveInitiativeCategories,
  updateInitiativeCategory,
} from '../../../modules/initiativeCategories.js';

const mapStateToProps = (state) => ({
  organizationId: selectCurrentOrganizationId(state),
});

const mapDispatchToProps = {
  createInitiativeCategory,
  retrieveInitiativeCategories,
  updateInitiativeCategory,
  deleteInitiativeCategory,
};

InitiativeCategoryFormModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

function InitiativeCategoryFormModal(props) {
  const {
    category,
    initiativeType,
    createInitiativeCategory,
    retrieveInitiativeCategories,
    updateInitiativeCategory,
    deleteInitiativeCategory,
    onHide,
    show,
  } = props;

  const defaultValues = {
    name: '',
    initiativeType,
  };

  const resource = category || defaultValues;

  const onSubmit = (values) => {
    const res = {
      ...resource,
      name: values.name,
      initiativeType: initiativeType || values.initiativeType,
    };

    return category
      ? updateInitiativeCategory(res.id, res)
      : createInitiativeCategory(res);
  };

  const onDelete = () => deleteInitiativeCategory(resource.id);

  const validate = useCallback((values) => {
    const errors = {};
    if (!values.name) {
      errors.name = 'Name is required';
    }

    if (!values.initiativeType) {
      errors.initiativeType = `${getOrgTermsContent('initiative')} Type is required`;
    }

    return errors;
  }, []);

  return (
    <FormModal
      createResource={onSubmit}
      updateResource={category && onSubmit}
      deleteResource={category && onDelete}
      onSubmitSuccess={() => retrieveInitiativeCategories()}
      onDeleteSuccess={() => retrieveInitiativeCategories()}
      onHide={onHide}
      resourceName="Category"
      resource={resource}
      show={show}
      validate={validate}
      customConfirmMessage={`Are you sure you want to delete the “${resource.name}”? 
        If it is used in Initiatives, it will remain available for the reporting purposes.`}
    >
      <InitiativeCategoryForm initiativeType={initiativeType} />
    </FormModal>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InitiativeCategoryFormModal);
